import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ConfigBaseFilter, ConfigService, ListLayout, ListLayoutMultipleComponent, ListSortOption } from 'gung-list';
import { Customer } from 'gung-standard';
import { DeliveryLocationsService, JeevesDeliveryLocation, JeevesOrderDeliveryAddress } from 'gung-standard-jeeves';
import { filter, first, Observable, of, ReplaySubject, switchMap, tap } from 'rxjs';
import { HlDisplayCustomerPodListTableViewComponent } from '../components/hl-display-customer-pod-list-table-view/hl-display-customer-pod-list-table-view.component';

@Injectable({
  providedIn: 'root'
})
export class HlDisplayDeliveryAddressesListConfigService implements ConfigService<JeevesDeliveryLocation> {
  public isLoaded: boolean = false;
  public customerSubject: ReplaySubject<Customer> = new ReplaySubject<Customer>(1);

  constructor(
    protected deliveryLocationsService: DeliveryLocationsService
  ) { }

  getItems(): Observable<JeevesDeliveryLocation[]> {
    return this.customerSubject.pipe(
      filter(customer => !!customer),
      switchMap(customer => this.deliveryLocationsService.getDeliveryLocationsForCustomer(customer.id).pipe(first())),
      tap(() => this.isLoaded = true)
    );
  }

  getFilters(): ConfigBaseFilter<JeevesDeliveryLocation>[] {
    return [];
  }

  getSortOptions(): ListSortOption<JeevesDeliveryLocation>[] {
    return [];
  }

  getBatchSizes(): number[] | undefined {
    return [24];
  }

  getLayouts(): ListLayout<JeevesDeliveryLocation>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => HlDisplayCustomerPodListTableViewComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'DeliveryLoacationsTable'
      }
    ];
  }

  getSearchTerms(item: JeevesDeliveryLocation): string[] {
    const terms = [];
    if (item.id) {
      terms.push(item.id);
    }

    if (item.extra?.companyName) {
      terms.push(item.extra.companyName);
    } else if (item.name) {
      terms.push(item.name);
    }

    if (item.extra?.address) {
      terms.push(item.extra.address);
    } else if (item.extra?.fr?.ftgpostadr2) {
      terms.push(item.extra.fr.ftgpostadr2);
    }

    if (item.extra?.city) {
      terms.push(item.extra.city);
    } else if (item.extra?.fr?.ftgpostadr3) {
      terms.push(item.extra.fr.ftgpostadr3);
    }

    if (item.extra?.postalCode) {
      terms.push(item.extra.postalCode);
    } else if (item.extra?.fr?.ftgpostnr) {
      terms.push(item.extra.fr.ftgpostnr);
    }

    return terms;
  }

  getItemId(item: JeevesDeliveryLocation): string {
    return item.id;
  }

  getSearchGroupCss(): string {
    return 'customer-list-search-group';
  }
}
